// extracted by mini-css-extract-plugin
export default {"buyer_listing__images":"BuyerListing_buyer_listing__images__ByT6k","buyer_listing__details":"BuyerListing_buyer_listing__details__dhezA","spin":"BuyerListing_spin__uXv66"};